module.exports = __webpack_public_path__ + "media/svg-new/test-ecfb7fae.svg";